export default __webpack_public_path__ + "static/media/clock.da9d9eef.svg";